import { useOutlet } from "react-router-dom";
import Section from "../rows/Section";
import { SubBar } from "../base/SubBar";

import {
  GetAppBarSection,
  GetAppBarSectionUrlsByID,
} from "../../utilities/Util";

export default function ProductLayout() {
  const appBarSection = "supplier-list_collapse";
  const appBarLabel = "product";
  const appBarPath = GetAppBarSectionUrlsByID(appBarSection, appBarLabel);

  const outlet = useOutlet();

  return (
    <>
      <h1>Product</h1>
      <Section>
        <SubBar
          pages={[
            { label: "總結", path: appBarPath },
            // { label: "列表", path: "/supplier/list" },
            { label: "新增", path: `${appBarPath}/add` },
            { label: "產品類型", path: `${appBarPath}/type` },
          ]}
        />
      </Section>
      <Section>{outlet}</Section>
    </>
  );
}
